import { resetSearchPosts } from 'entity/post/postRedux';
import SearchAction from '../reducer/searchRedux';
import ProductAction from '../reducer/productRedux';
import ProfileAction from '../reducer/profileRedux';
import OpinionAction from '../reducer/opinionRedux';

const searchWithTerm = term => {
  const params = { term };
  return SearchAction.searchRequest(params);
};

const searchComparison = (result = [], limit = 0) => {
  if (limit > 0) {
    return SearchAction.searchComparison(result.slice(0, limit));
  }
  return SearchAction.searchComparison(result);
};

const searchCategories = (result = [], limit = 0) => {
  if (limit > 0) {
    return SearchAction.searchCategories(result.slice(0, limit));
  }
  return SearchAction.searchCategories(result);
};

const searchGroups = (result = [], limit = 0) => {
  if (limit > 0) {
    return SearchAction.searchGroups(result.slice(0, limit));
  }
  return SearchAction.searchGroups(result);
};

const searchRecent = result => {
  return SearchAction.searchRecent(result);
};

const searchQuestionWithTerm = ({ term, perPage = 3 }, meta) => {
  const params = { term, per_page: perPage };
  return SearchAction.searchQuestionsRequest(params, meta);
};

const searchQuestionNextPage = ({ term, pagination }, meta = {}) => {
  const { currentPage } = pagination;
  const page = Number(currentPage || 1) + 1;
  meta.isFetchingMorePosts = true;
  const params = { term, page };
  return SearchAction.searchQuestionsRequest(params, meta);
};

const searchOpinionWithTerm = ({ term, perPage = 3, page = 1 }, meta = {}) => {
  const params = { term, per_page: perPage, page };
  return SearchAction.searchOpinionRequest(params, meta);
};

const searchProfileWithTerm = ({ term, perPage = 4 }, meta) => {
  const params = { term, per_page: perPage };
  return SearchAction.searchProfilesRequest(params, meta);
};

const searchProfileNextPage = ({ term, pagination }, meta = {}) => {
  const { currentPage } = pagination;
  const page = Number(currentPage || 1) + 1;
  const params = { term, page };
  meta.isFetchingMore = true;
  return SearchAction.searchProfilesRequest(params, meta);
};

const searchProductWithTerm = ({ term, perPage = 3 }, meta) => {
  const params = { term, per_page: perPage };
  return SearchAction.searchProductsRequest(params, meta);
};

const searchProductNextPage = ({ term, page }, meta = {}) => {
  const params = { term, page, per_page: 8 };
  return SearchAction.searchProductsRequest(params, meta);
};

const showMobileSearchPage = () => {
  return SearchAction.setMobileSearchPage(true);
};

const closeMobileSearchPage = () => {
  return SearchAction.setMobileSearchPage(false);
};

const setSearchTerm = searchTerm => {
  return SearchAction.setSearchTerm(searchTerm);
};

const resetQuestionResult = () => {
  return resetSearchPosts();
};

const resetOpinionResult = () => {
  return OpinionAction.resetSearchOpinions();
};

const resetProfileResult = () => {
  return ProfileAction.resetSearchProfiles();
};

const resetProductResult = () => {
  return ProductAction.resetSearchProducts();
};

export {
  searchWithTerm,
  searchQuestionWithTerm,
  searchQuestionNextPage,
  searchProfileWithTerm,
  searchProfileNextPage,
  searchProductWithTerm,
  searchProductNextPage,
  searchOpinionWithTerm,
  searchCategories,
  showMobileSearchPage,
  closeMobileSearchPage,
  resetOpinionResult,
  resetQuestionResult,
  resetProductResult,
  resetProfileResult,
  setSearchTerm,
  searchComparison,
  searchRecent,
  searchGroups,
};
